import { Injectable, Injector } from '@angular/core';

import { AppinfoPreService } from './appinfo-pre.service';
import { LbColumnType } from './appinfo.service';

export interface ColumnOperator {
	text: string; // Name for displaying
	name: string; // Name for db use
	symbol: string; // Symbol
}
export interface ColumnFilter {
	col: string; // column name
	typ: LbColumnType; // column type
	op: string; // operator
	val: any; // value
}
export interface Gfo {
	logic: string;
	filters: ColumnFilter[];
	src_tab?: string;
	ret_col?: string;
}

@Injectable()
export class CommonGfoService {

	public filterOperators = {
		contain: 'contains',
		startWith: 'startswith',
		equal: 'eq',
		between: 'between',
		in: 'in',
		lessThan: 'lt',
		lessThanOrEqual: 'lte',
		greaterThan: 'gt',
		greaterThanOrEqual: 'gte',
		overlap: 'overlaps',
		like: 'like'
	};
	public filterLogics = {
		and: 'and',
		or: 'or'
	};
	public columnOperators: ColumnOperator[] = [
		{text: 'equal', name: 'eq', symbol: '='},
		{text: 'lessThan', name: 'lt', symbol: '<'},
		{text: 'lessThanOrEqual', name: 'lte', symbol: '<='},
		{text: 'greaterThan', name: 'gt', symbol: '>'},
		{text: 'greaterThanOrEqual', name: 'gte', symbol: '>='},
		{text: 'in', name: 'in', symbol: 'in'},
		{text: 'contain', name: 'contains', symbol: 'contain'},
		{text: 'startWith', name: 'startswith', symbol: 'startWith'},
		{text: 'between', name: 'between', symbol: 'between'}
	];

	public tables: any = {
		userSubView: {
			name: 'lba.v_user_subscription',
			columns: {
				customerId: 'cus_id',
				userId: 'usr_id',
				userEmail: 'usr_email',
				subModeCode: 'sub_mod_cd',
				subExpire: 'sub_expire',
				role: 'rol_cgs_role'
			}
		},
		subsView: {
			name: 'lba.v_subscriptions',
			columns: {
				customerId: 'sub_cus_id'
			}
		}
	};

	constructor(
		private appinfoPreService: AppinfoPreService
	) {}

	getFilter(column, type, operator, value): ColumnFilter {
		if (!type) {
			type = this.appinfoPreService.columnMap[column].type ? this.appinfoPreService.columnMap[column].type : 'text';
		}
		return {
			col: column, // 'sub_cus_id',
			typ: type, // 'number',
			op: operator, // 'eq',
			val: value // 1027
		};
	}
	getReturnColumnsByNames(names: string[], table) {
		let returnColumns = '';
		for (const column of Object.keys(this.tables[table].columns)) {
			returnColumns += this.tables[table].columns[column] + ',';
		}
		// remove last comma;
		returnColumns = returnColumns.replace(/,\s*$/, '');
		return returnColumns;
	}
	getGfo(logic: string, tableName: string, returnColumns: string, filters: ColumnFilter[]): Gfo {
		return {
			logic: logic, // 'and',
			src_tab: tableName, // 'lba.v_subscriptions',
			ret_col: returnColumns, // null,
			filters: filters // array of filter
		};
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/common-gfo.service.ts